import { Button, Col, Form, Modal, Row, Upload, UploadProps } from 'antd'
import { useEffect, useState } from 'react'
import { CloudDownloadOutlined, FileExcelOutlined, UploadOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { API_BASE_URL } from 'constants/index'
import { getAuthToken } from 'helpers/FetchHelper'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Typography } from 'antd';
import { Flex } from 'widgets/Box'
import { formatDateToUnderscore } from 'helpers'
import { customerService, orderService } from '../../../services'

const { Text } = Typography;

const ModalBody = styled.div`
  padding-right: 10px;
    .red-color {
    color: red;
    padding-bottom: 1px;
    display: inline-block;
  }
  > div {
    padding: 0;
    box-shadow: none;
  }
  .box-import-order {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
`

const ButtonGroups = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`
const ImportOrderModal = ({ open, onCancel, customerProfile, totalProcessing, totalOrder }) => {
    const [form] = Form.useForm()
    const auth = getAuthToken()

    const [loadingDownloadTemplete, setLoadingDownloadTemplete] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [dataErrorFile, setDataErrorFile] = useState<any>([])
    const [dataErrorString, setDataErrorString] = useState<string>("")
    const [dataErrorMoneyString, setDataErrorMoneyString] = useState<string>("")
    const [dataErrorMoney, setDataErrorMoney] = useState<boolean>(false)
    const [msgImport, setMsgImport] = useState<string>('')
    useEffect(() => {
        if (customerProfile?.orderImport != null) {
            setLoading(true)
        } else {
            setLoading(false)
            setDataErrorFile([])
            setDataErrorString("");
            setDataErrorMoneyString("");
            setDataErrorMoney(false);
        }
    }, [customerProfile]);

    const props: UploadProps = {
        name: 'file',
        action: `${API_BASE_URL}/orders/import-order`,
        headers: {
            authorization: `Bearer ${auth}`,
        },
        showUploadList: false,
        beforeUpload() {
            setDataErrorFile([])
            setDataErrorString("");
            setDataErrorMoneyString("");
            setMsgImport('');
            setDataErrorMoney(false);
            setLoading(true)
        },
        onChange(info) {
            if (info.file.status === 'done') {
                const response = info.file.response;
                if (response?.error == true) {
                    setLoading(false)
                    const data = response?.data;
                    const message = response?.message;
                    if (message == 'file') {
                        setDataErrorFile(data.orders)
                    } else if (message == 'money') {
                        setDataErrorMoney(true);
                        setDataErrorMoneyString(data?.money)
                    } else {
                        setDataErrorString(message)
                    }
                } else {
                    return;
                }

            } else if (info.file.status === 'error') {
                setLoading(false)
                console.error(`${info.file.name} file upload failed.`);
            }
        },
    };
    const handleCancel = () => {
        onCancel();
        setDataErrorFile([])
        setDataErrorString("");
        setDataErrorMoneyString("");
        setDataErrorMoney(false);

    }
    const handleDownloadTemplte = async () => {
        setLoadingDownloadTemplete(true);
        try {
            const response: any = await fetch(`${API_BASE_URL}/orders/export-template-import-order`, {
                method: 'GET',
                headers: {
                    Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    Authorization: `Bearer ${auth}`,
                },
            })
            const name = `file-mau-import-${formatDateToUnderscore(new Date())}.xlsx`;
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLoadingDownloadTemplete(false)
        } catch (error) {
            console.error("Download failed", error);
            setLoadingDownloadTemplete(false)
        }
    }

    const exportToExcel = () => {
        const name = `loi-file-import-${formatDateToUnderscore(new Date())}.xlsx`;
        const result = dataErrorFile.map(e => ({ "Sheet Orders": e }));
        const worksheet = XLSX.utils.json_to_sheet(result);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        const fileData = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(fileData, name);
    };

    const handleKill = () => {
        if(confirm('Tắt Tiến Trình - Đồng nghĩa với quá trình tạo đơn sẽ thất bại, bạn cần check lại các đơn đã tạo thành công và đơn thất bại, để đảm bảo không bị trùng lặp dữ liệu hoặc các đơn hàng không đúng')){
            customerService.killImportProcess((data) => {
                location.reload();
            })
        }
    }

    const checkImportStatus = () => {
        orderService.checkImportStatus((data) => {
            const row = data?.data?.row;
            if(row?.status === 'DOING'){
                setMsgImport(row?.reason);
                setTimeout(function (){
                    checkImportStatus();
                },3000);
            }else if(row?.status === 'DONE'){
                setMsgImport(row?.reason);
                setLoading(false);
                setTimeout(function (){
                    location.reload();
                },2000);
            }
        });
    }

    useEffect(() => {
        if(loading){
            setTimeout(function (){
                checkImportStatus();
            },2000);
        }
    }, [loading]);

    return (
        <Modal
            title={<p style={{ fontSize: '20px', fontWeight: 700 }}><FileExcelOutlined />Tạo đơn bằng file Excel</p>}
            open={open}
            footer={false}
            closable={!loading}
            onCancel={() => {
                if (!loading) {
                    handleCancel()
                }
            }}
            width={700}
            maskClosable={false}
        >
            <ModalBody>
                <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <div className="box-import-order">
                        <div className="item-order">
                            <Upload {...props} showUploadList={false}>
                                <Button loading={loading} disabled={loading} icon={<UploadOutlined />}>Upload file excel</Button>
                            </Upload>
                        </div>
                        <div className="item-templete">
                            <Button onClick={() => handleDownloadTemplte()} loading={loadingDownloadTemplete} disabled={loadingDownloadTemplete || loading} icon={<CloudDownloadOutlined />}>Download file mẫu</Button>
                        </div>
                    </div>
                    <Flex gap="middle" alignItems="center" justifyContent="center" flexDirection="column">

                        {loading && (
                            <>
                                <Text type="secondary">Đang xử lý tập tin...</Text>
                            </>
                        )}
                        {dataErrorString != "" && (
                            <Text type="danger">{dataErrorString}</Text>
                        )}
                        {dataErrorMoney == true && (
                            <Text type="danger">Số dư ký quỹ còn thiếu {dataErrorMoneyString}đ để tạo đơn vận, vui lòng <b>nạp quỹ</b> để có thể tiếp tục tạo đơn!</Text>
                        )}
                        {dataErrorFile.length > 0 && (
                            <Text>Lỗi file nhập liệu, vui lòng download file xem lỗi <b onClick={(e) => exportToExcel()} className="can-click red-color">tại đây</b></Text>
                        )}
                        {msgImport != "" && (
                          <Text type="secondary">{msgImport}</Text>
                        )}
                    </Flex>
                    <Row style={{ marginTop: "20px" }}>
                        <Col span={24}>
                            <ButtonGroups>
                                <Button
                                    size='large'
                                    loading={loading} disabled={loading}
                                    onClick={() => {
                                        if (!loading) {
                                            handleCancel()
                                        }
                                    }}
                                >
                                    Thoát
                                </Button>
                                {loading && ( <Button
                                    size='large'
                                      onClick={() => {
                                          if (loading) {
                                              handleKill()
                                          }
                                    }}
                                    >Tắt tiến trình</Button>)
                                }
                            </ButtonGroups>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default ImportOrderModal
